import AdminLayout from './adminLayout.component';

export default AdminLayout;